import { createContext } from 'react';

export type EditAmountCtx = {
  shouldOpenEditAmountModal: boolean;
  showEditAmountErrorAlert: boolean;
  sendEditAmountError: string;
};

const EditAmountDialogueContext = createContext<EditAmountCtx>({
  shouldOpenEditAmountModal: false,
  showEditAmountErrorAlert: false,
  sendEditAmountError: '',
});

export default EditAmountDialogueContext;
